import { type PermissionEntityId } from '@terros/common'
import { type PermGraphNode } from './types'

export type PermGraphNodeAccess = {
  canEdit: boolean
  reason?: string
}

export function getPermGraphNodeAccess({
  currentUserId,
  node,
}: {
  currentUserId: PermissionEntityId | undefined
  node: PermGraphNode
}): PermGraphNodeAccess {
  if (node.kind === 'defaultRole')
    return { canEdit: false, reason: 'Built-in defaults are read-only. Change the role or team that inherits from it.' }
  if (node.entityId === currentUserId) return { canEdit: false, reason: 'You cannot edit your own permissions.' }
  if (node.kind === 'role' && node.roleType === 'admin') {
    return { canEdit: false, reason: 'Protected admin roles are read-only.' }
  }
  return { canEdit: true }
}
